import { render, staticRenderFns } from "./ClosedBetaInfo.vue?vue&type=template&id=16e291b8&scoped=true&"
import script from "./ClosedBetaInfo.vue?vue&type=script&lang=js&"
export * from "./ClosedBetaInfo.vue?vue&type=script&lang=js&"
import style0 from "./ClosedBetaInfo.vue?vue&type=style&index=0&id=16e291b8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e291b8",
  null
  
)

export default component.exports